<template>
    <div class="baidu_map_input" v-loading="loading">
        <el-autocomplete
            :popper-class="'map_input-popper ' + popperClass"
            v-model="address"
            :fetch-suggestions="handleFetch"
            :placeholder="placeholder"
            @select="handleSelect"
            @input="handleInput"
            :disabled="disabled"
        >
            <template slot-scope="{ item }">
                <div class="title">{{ item.title }}</div>
                <div class="address">{{ item.address }}</div>
            </template>
            <el-button slot="append" class="el-icon-map-location" title="地图选点" @click="openAddressMap"></el-button>
        </el-autocomplete>
        <address-map-modal ref="addressMapRef" @setSelectedAddress="setSelectedAddress" />
    </div>
</template>
<script>
import common from '../../../../../../../api/common.js';
import loadMap from './loadBMap.js';
import { dealDetailAddress, filterDetailAddress } from './methods.js';
import AddressMapModal from './AddressMapModal.vue';

let NewBMap = null; // 地图对象
let local = null; // 地图搜索对象
let queryCallback = null; // 搜索回调
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请输入内容'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        popperClass: {
            type: String,
            default: ''
        }
    },
    components: { AddressMapModal },
    data() {
        return {
            loading: false,
            address: '',
            fullAddress: ''
        };
    },
    methods: {
        init({ provinceName, cityName, districtName, fullAddress }) {
            this.fullAddress = fullAddress;
            this.address = dealDetailAddress(provinceName, cityName, districtName, '', fullAddress);
        },
        handleFetch(query, callback) {
            if (query) {
                loadMap().then(BMap => {
                    NewBMap = BMap;
                    local = this.initLocalSearch();
                    local.search(query);
                    queryCallback = callback;
                }).catch(() => {
                    // console.log('loadMap err...', err);
                    // eslint-disable-next-line standard/no-callback-literal
                    callback([]);
                });
            } else {
                // eslint-disable-next-line standard/no-callback-literal
                callback([]);
            }
        },
        // 初始化地图搜索
        initLocalSearch() {
            const _local = new NewBMap.LocalSearch(new NewBMap.Point('113.216596', '22.913121'), {
                // 智能搜索
                onSearchComplete: results => {
                    const len = results.getNumPois();
                    const addressOptions = [];
                    if (len <= 0) {
                        queryCallback && queryCallback(addressOptions);
                        return this.$message.warning('没有搜索到相关地址');
                    }
                    for (let i = 0; i < len; i++) {
                        if (i < 10) {
                            addressOptions.push(results.getPoi(i));
                        }
                    }
                    queryCallback && queryCallback(addressOptions);
                }
            });
            return _local;
        },
        handleSelect(val) {
            this.fullAddress = val.address + val.title;
            this.getGisInfoByLngAndLat(this.fullAddress, val.point);
        },
        handleInput() {
            // if (!val) {
            //     this.$emit('setSelectedAddress', null);
            // }
        },
        openAddressMap() {
            // console.log(this.$refs);
            // 地图选址
            this.$nextTick(() => {
                this.$refs.addressMapRef.open(this.fullAddress, this.type);
            });
        },
        getGisInfoByLngAndLat(fullAddress, point) {
            this.loading = true;
            const { lng, lat } = point;
            common.geDetailAddressByGis({ lng, lat }).then(res => {
                if (res && +res.code === 0) {
                    const { code, province, city, county, name } = res.data;
                    const type = this.type;
                    this.address = dealDetailAddress(province, city, county, name, fullAddress);
                    this.$emit(
                        'setSelectedAddress',
                        {
                            [`${type}DetailAddr`]: filterDetailAddress(province, city, county, name, fullAddress),
                            [`${type}ProvinceCode`]: code && code.length > 2 ? code.slice(0, 3) : '',
                            [`${type}ProvinceName`]: province,
                            [`${type}CityCode`]: code && code.length > 4 ? code.slice(0, 5) : '',
                            [`${type}CityName`]: city,
                            [`${type}DistrictCode`]: code && code.length > 6 ? code.slice(0, 7) : '',
                            [`${type}DistrictName`]: county,
                            [`${type}TownCode`]: code,
                            [`${type}TownName`]: name,
                            [`${type}Lng`]: lng,
                            [`${type}Lat`]: lat,
                            // address: filterDetailAddress(province, city, county, name, address)
                            fullAddress
                        },
                        type
                    );
                }
            }).catch(() => {
                this.$message.warning('未获取到当前所选地址的详细信息，请重新选择');
            }).finally(() => {
                this.loading = false;
            });
        },
        setSelectedAddress(data, type) {
            this.address = dealDetailAddress(data[`${type}ProvinceName`], data[`${type}CityName`], data[`${type}DistrictName`], data[`${type}TownName`], data[`${type}DetailAddr`]);
            this.fullAddress = data[`${type}DetailAddr`];
            this.$emit('setSelectedAddress', data, type);
        }
    }
};
</script>

<style lang="less">
.baidu_map_input {
    .el-autocomplete {
        width: 100%;
        .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0
        }
    }
}
.map_input-popper .el-autocomplete-suggestion__list > li {
    display: flex;
    justify-content: space-between;
    .title {
        width: 40%;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .address {
        width: 60%;
        text-align: right;
        padding-left: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>
